import { Component, lazy, useEffect, useState } from "react";
import { isMobile, useForceUpdate, getQueryParam } from "../../services/shared";
import './Header.scss'

import { lowerCaseAllParamKeys } from "../../constants";

import backIcon from '../../assets/images/icons/left-arrow.svg';

import logo from '../../assets/images/logo.svg';
import star from '../../assets/images/icons/star.svg';
import inverse from '../../assets/images/inverse-logo.svg';
import laborday from '../../assets/images/laborday-banner.png';
import {Link, useHistory} from "react-router-dom";
import sparksDesktop from '../../assets/images/sparksDesktop.png';
import sparksMobile from '../../assets/images/mobileSparks.png';

const HeaderLogo = lazy(() => import("../../pages/Deal/KiaDealsPage/HeaderLogo/HeaderLogo"));

const Header = ({enableBack, className, baseUrl = '/', inverseLogo= false, onBack, showBanner=false,bgColor})=>{
    const history=useHistory();
    const params = new URLSearchParams(window.location.search);
    const currentDate = new Date();
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const currentMonthIndex = currentDate.getMonth();
    const currentMonthName = monthNames[currentMonthIndex];
    const lowerCaseParams = lowerCaseAllParamKeys();

    const [openMobileDrawer , setOpenMobileDrawer] = useState(false);
    const handleLinkClick = (clickedMenuItem) => {
        const urlParams = new URLSearchParams();
        const existingParams = new URLSearchParams(window.location.search);

        for (const [key, value] of existingParams) {
            urlParams.append(key, value);
        }
        const isBodyFilterApplied=params.get('bodyFilters')
        if(isBodyFilterApplied && clickedMenuItem!=="topSuvUrl"){
            urlParams.delete('bodyFilters')
        }
        const isSortPresent=params.get('sort');
        const isOrderPresent=params.get('order')
        if(isSortPresent && isOrderPresent){
            urlParams.delete('sort')
            urlParams.delete('order')
        }
        const trendingCarUrl = '/listing?sort=popularity&order=desc' +`${urlParams.toString()!==""?'&':''}` +urlParams.toString();
        const topSuvUrl=`/listing?sort=popularity&order=desc&bodyFilters=SUV`+`${urlParams.toString()!==""?'&':''}`+urlParams.toString();
        const bestSellingUrl=`/listing?sort=popularity&order=desc`+`${urlParams.toString()!==""?'&':''}`+urlParams.toString();
        const logoUrl="/"+ '?'+urlParams.toString();
       // const blogUrl="/blog";
        let newUrl=''

        if(clickedMenuItem==="trendingCar"){
            newUrl=trendingCarUrl;
        }
        if(clickedMenuItem==="topSuv"){
            newUrl=topSuvUrl;
        }
        if(clickedMenuItem==="bestSellingCar"){
            newUrl=bestSellingUrl;
        }
        // if(clickedMenuItem==="blog"){
        //     newUrl=blogUrl;
        //
        // }
        if(clickedMenuItem==="logo"){
            newUrl=logoUrl;
            window.dataLayer?.push({
                'event': "Header Logo",
            })
        }
        history.push(newUrl);
    };


    return(
        <>
        <header  className={`main-header flex items-center ${bgColor} ${className} ${isMobile() && enableBack?'has-back':''}` }
        // style={{
        //     backgroundImage: window.innerWidth > 760
        //         ? (params.get('tmpl')==='t3' && (window.location.pathname === '/deals'|| window.location.pathname === '/')) && `url(${sparksDesktop})`
        //         : (params.get('tmpl')==='t3' && (window.location.pathname === '/deals'|| window.location.pathname === '/')) && `url(${sparksMobile})`
        // }}
            >
            <div className={`container flex items-center ${lowerCaseParams['utm_source'] && lowerCaseParams['utm_source']?.toLowerCase() === 'buyerlink' ? ' justify-space-between' : ''}`}>
                {isMobile() && enableBack &&
                    <span className="back-button" onClick={()=>{
                        window.dataLayer?.push({
                            'event': 'Header back clicked',
                            'eventCallback' : (id)=>{
                                onBack();
                            },
                            'eventTimeout' : 2000,
                        })
                        
                    }}><img src={backIcon}></img></span>
                }
                {window.location.pathname !== '/deals_ae' && window.location.pathname !== '/marketplace' && window.location.pathname !== '/find-cars' && window.location.pathname !== '/deals' && !(window.location.pathname.includes("/make")) && window.location.pathname !== '/' && window.location.pathname !== '/thankyou' && window.location.pathname !== '/privacy-policy' && window.location.pathname !== '/about' && window.location.pathname !== '/contact' && window.location.pathname !== '/dsmi' && <span className={`mobile-menu-icon ${(inverseLogo ) ? 'inverted' : ''}`} onClick={()=>{
                        setOpenMobileDrawer(true)
                    }}>&#9776;</span>}

                {/* Buyerlink Make and Model */}
                {
                    window.location.pathname === '/deals' && lowerCaseParams['utm_source'] && lowerCaseParams['utm_source']?.toLowerCase() === 'buyerlink' && 
                    (
                        <div className="buyerlink-make-model">
                            <HeaderLogo />
                            <span className="modelName">{`${params.get('make')?.toUpperCase()} ${params.get('model')?.toUpperCase()}`}</span>
                        </div>
                    )
                }
                
                <a onClick={()=>handleLinkClick('logo')} style={(window.location.pathname==="/thankyou" && window.innerWidth<700)?{justifyContent:"flex-start"}:{}}>
                    {
                        (inverseLogo) ?
                        <img alt="Get Car Deals" width="80" height="30" src={inverse} /> :
                        <img alt="Get Car Deals" width="80" height="30" src={logo} />
                    }
                </a>


                {window.location.pathname !== '/deals_ae' &&  <div className={`left-drawer ${openMobileDrawer?'open':''}`}>
                        <span className="close" onClick={()=>{
                            setOpenMobileDrawer(false);
                        }}>&#10005;</span>
                       
                        <>
                            <ul className={`right-menu-items ${isMobile()?'mobile-font':''}`}>
                                {/* {
                                    !(window.location.pathname==="/marketplace") && !(window.location.pathname==="/deals") && !(window.location.pathname.includes("/make")) && <li>
                                        <a  onClick={()=>handleLinkClick('trendingCar')} >Trending cars</a>
                                    </li>
                                } */}
                                
                                {
                                    window.location.pathname==="/listing" &&   <li >
                                        <a href="/marketplace" >Market place</a>
                                    </li>
                                }
                                {/*<li>*/}
                                {/*    <a  onClick={()=>handleLinkClick('topSuv')} >Top SUVs</a>*/}
                                {/*</li>*/}
                                {/*<li >*/}
                                {/*    <a  onClick={()=>handleLinkClick('bestSellingCar')} >Best Selling cars</a>*/}
                                {/*</li>*/}
                                {/* <li >
                                    <a href="/listing?sort=popularity&order=desc&fuelType=Electric">Electric cars</a>
                                </li> */}
                            </ul>
                            <ul className={`right-menu-items margin-left-auto ${isMobile()?'mobile-font':''}`} style={{marginTop: '0'}}>
                                {/* uncomment it when you want to show about and contact in the header  */}
                                {/* <li>
                                    <a href={`/about?${getQueryParam(params)}`}>About Us</a>
                                </li>
                                <li>
                                    <a href={`/contact?${getQueryParam(params)}`} >Contact Us</a>
                                </li> */}
                                {/*<li>*/}
                                {/*    <a  onClick={()=>handleLinkClick('blog')} >Blog</a>*/}
                                {/*</li>*/}
                                {/*<li><a href={`/blog?${getQueryParam(params)}`}>Blog</a></li>*/}
                            </ul>
                        </>
                    </div>}
                    
                

            </div>
        </header>
        {
            showBanner && 
            // <div className="july-4th-banner-wrapper">
            //     <div className="july-4th-banner container">
            //         <div className="border-block left"></div>
            //         <div className="border-block right"></div>
            //         <div className="july-4th-banner--content">
            //             <span>&#9733;</span>
            //             4th of july
            //             <span>&#9733;</span>
            //             deals
            //             <span>&#9733;</span>
            //         </div>
                    
            //     </div>
            // </div>
            // <div className="laborday-banner-wrapper">
            //     <div className="container">
            //         <div className="top-line"></div>
            //         <div className="line"></div>
            //         <div className="line"></div>
            //         <div className="line"></div>
            //         <div className="line"></div>
            //         <div className="line"></div>
            //         <div className="bottom-line"></div>
            //         <div className="image-container">
            //             <img src={laborday}></img>
            //         </div>
            //     </div>
            // </div>
            // <div className="halloween-banner-wrapper">
            //     <div className="container">
            //         <div className="spider"></div>
            //         <div className="center">
            //             <div className="stars"></div>
            //             <div className="text"></div>
            //             <div className="stars"></div>
            //         </div>
            //         <div className="pumpkin"></div>
            //     </div>
            // </div>
            // <div className="thanks-giving-banner-wrapper">
            //     <div className="container">
            //         <div className="left-leaf"></div>
            //         <div className="text"></div>
            //         <div className="right-leaf"></div>
            //     </div>
            // </div>
            <div className="christmas-banner-wrapper">
                <div className="container">
                    <div className="left-decor"></div>
                    <div className="text"></div>
                    <div className="right-decor"></div>
                </div>
            </div>
            
        }
        
    </>)
}
export default Header;
